import { Component } from "@angular/core";
import { NgForOf } from "@angular/common";
import { SharedComponentsModule } from "../../../shared/module/shared-components.module";
import { BmButtons } from "../../pojo/bm-enums";

@Component({
  selector: 'app-bm-loading-state',
  templateUrl: './bm-loading-state.component.html',
  styleUrls: ['./bm-loading-state.component.scss'],
  standalone: true,
  imports: [
    NgForOf,
    SharedComponentsModule,
  ],
})
export class BmLoadingStateComponent {

  protected readonly BmButtons = BmButtons;
}
